import React from 'react'

export default ({ artists }) => {
  return (
    <div>
      {artists.map((artist, i) => <span key={`artist-${i}`}>{artist.name}{i + 1 !== artists.length && ', '}</span>)}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Components/Artists.js